import {Validation, ValidationRule} from "@vuelidate/core";
import {Ref, unref} from "@vue/composition-api";
import {AxiosError} from "axios";

export const capitalize = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1)
}


interface ValidationArgs {
    [K: string]: ValidationRule | ValidationArgs
}

export const validateState: <VArgs extends ValidationArgs>(v: Ref<Validation<VArgs>>, property: keyof VArgs & string) => null | boolean =
    (v, property) => {
        const validation = unref(v);
        if (typeof validation[property] === 'undefined') {
            throw new Error('Validation property ' + property + ' does not exist');
        }
        const {$dirty, $error} = validation[property];
        return $dirty ? !$error : null;
    }